import { render, staticRenderFns } from "./SpeedDialExtenDetail.vue?vue&type=template&id=ce88e754"
import script from "./SpeedDialExtenDetail.vue?vue&type=script&lang=ts"
export * from "./SpeedDialExtenDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports